import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#20787d',
    secondary: '#1c5154',
    white: '#ffffff',
    black: '#000000',
  },
});